import { Dialog } from '@headlessui/react';
import EmojiPickerReact, { EmojiStyle, Theme } from 'emoji-picker-react';

export function EmojiPicker({
  open,
  setOpen,
  select,
}: {
  open: boolean;
  setOpen: (val) => void;
  select: (val: any) => void;
}) {
  const onEmojiSelect = emoji => {
    select(emoji);
    setOpen(false);
  };
  const onClose = e => {
    setOpen(false);
  };

  return (
    <Dialog
      as={'div'}
      className={'absolute top-1/2 left-1/2 transform z-front -translate-x-1/2 -translate-y-1/2'}
      open={open}
      onClose={onClose}
    >
      <Dialog.Panel>
        <EmojiPickerReact
          lazyLoadEmojis={true}
          theme={Theme.LIGHT}
          emojiStyle={EmojiStyle.NATIVE}
          onEmojiClick={({ emoji }) => onEmojiSelect(emoji)}
        />
      </Dialog.Panel>
    </Dialog>
  );
}

export const Emoji = props => (
  <span
    className="emoji"
    role="img"
    aria-label={props.label ? props.label : ''}
    aria-hidden={props.label ? 'false' : 'true'}
  >
    {props.symbol}
  </span>
);
